export const businessInfo = {
  name: "Sound Hire Tarneit",
  shortName: "SH",
  tagline: "Premium Sound & Lighting Hire",
  subtitle: "Professional PA Systems, Speakers & Party Lights for Every Occasion",
  description: "Your one-stop solution for high-quality sound equipment hire in Tarneit and the Wyndham area. From intimate gatherings to large events, we deliver crystal-clear audio that makes your event unforgettable.",
  logo: "/logo.png",
  contact: {
    name: "Mir",
    phones: ["04 9161 7474", "04 7068 4981"],
    whatsapp: "61491617474",
    email: "soundhiretarneit@gmail.com",
    facebook: "https://facebook.com/soundhiretarneit",
    facebookHandle: "fb/soundhiretarneit",
    location: "Tarneit, VIC - Wyndham Area"
  }
};

export const services = [
  {
    id: 1,
    title: "PA / Audio Rentals",
    description: "Professional PA systems for any venue size. Crystal-clear sound for speeches, music, and presentations.",
    icon: "Volume2"
  },
  {
    id: 2,
    title: "Speaker Hire",
    description: "Yamaha powered speakers with inbuilt woofers on professional stands. Powerful, reliable sound.",
    icon: "Speaker"
  },
  {
    id: 3,
    title: "Corporate Events",
    description: "Complete audio setups for corporate functions, and community gatherings. Can be combined with projector and screen hire for presentations and conferences. Wide range of equipment to suit all event types and sizes.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Weddings / Birthdays",
    description: "Make your special day sound amazing. Tailored packages for weddings, birthdays, and celebrations.",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Audio Visual Setup",
    description: "Projector, screen, TV's and audio combined for presentations, movie nights, and multimedia events.",
    icon: "Projector"
  },
  {
    id: 6,
    title: "Custom Packages",
    description: "Need something specific? We create bespoke packages tailored to your exact requirements.",
    icon: "Settings"
  }
];

export const packages = [
  {
    id: 1,
    name: "Essential Sound",
    price: 100,
    tag: "Great Value",
    items: [
      "2 x Yamaha Speakers 12inch/1000w with Stands",
      "1 x 6ch Audio Mixer (Connect your Laptop/Mobile Phone via Bluetooth to the mixer)",
      "All necessary cables for connections"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Sound + Mic",
    price: 125,
    tag: "Popular",
    items: [
      "2 x Yamaha Speakers 12inch/1000w with Stands",
      "1 x 6ch Audio Mixer (Connect your Laptop/Mobile Phone via Bluetooth to the mixer)",
      "1 x Microphone",
      "1 x Microphone Stand"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Full PA System",
    price: 150,
    tag: "Best Audio",
    items: [
      "2 x Yamaha Speakers 12inch/1000w with Stands",
      "1 x 6ch Audio Mixer (Connect your Laptop/Mobile Phone via Bluetooth to the mixer)",
      "1 x Microphone - Wireless Handheld / Lapel (Collar) / Headset (Ear) Microphone",
      "1 x Microphone Stand"
    ],
    popular: false
  },
  {
    id: 4,
    name: "Speaker & Lights",
    price: 150,
    tag: "Party Vibe",
    items: [
      "2 x Yamaha Speakers - 12inch/1000w with Stands",
      "1 x 6ch Audio Mixer (Connect your Laptop/Mobile Phone via Bluetooth to the mixer)",
      "2 x Sound Activated - Floor Disco Lights",
      "1 x PartyBar Disco Light with Stand",
      "Fog Machine (Optional)"
    ],
    popular: false
  },
  {
    id: 5,
    name: "Ultimate Party",
    price: 200,
    tag: "Best Seller",
    items: [
      "2 x Yamaha Speakers - 15inch/1000w with Stands",
      "1 x 6ch Audio Mixer (Connect your Laptop/Mobile Phone via Bluetooth to the mixer)",
      "2 x Sound Activated - Floor Disco Lights",
      "2 x PartyBar Disco Light with Stand",
      "Fog Machine (Optional)"
    ],
    popular: true
  }
];

export const additionalServices = [
  {
    title: "Yamaha DBR Speakers",
    description: 'Yamaha DBR 12"/15" Speakers & Subwoofer available for extra cost. Perfect for professional DJ setups.',
    note: "Extra cost applies"
  },
  {
    title: "Projector & Screen",
    description: "Projector and screen available for hire. Great for presentations, movie nights, and photo slideshows.",
    note: "Available for hire"
  },
  {
    title: "Inverter Generator",
    description: "2.0kVA Inverter Generator available for outdoor use. Combine with any package for events without power access.",
    note: "Generator hire extra"
  }
];

export const faqs = [
  {
    question: "What areas do you deliver to?",
    answer: "We provide speaker hire and PA system hire across all of Melbourne. We’re based in the Western suburbs (Tarneit/Werribee area) and regularly deliver to homes, community centres, halls, and venues throughout Melbourne. Delivery fees may apply depending on distance."
  },
  {
    question: "How early should I book my speaker hire?",
    answer: "We recommend booking your speaker hire in Melbourne at least 1–2 weeks in advance, especially for weekends and busy event seasons. Last-minute bookings are welcome and subject to availability."
  },
  {
    question: "Do you set up the sound system?",
    answer: "Yes — all our sound system hire packages include full setup and pack-down. We make sure everything is tested and ready before your event begins and safely packed away afterwards."
  },
  {
    question: "How can I connect my music?",
    answer: "You can easily connect your phone, laptop or tablet via Bluetooth or cable to play music through our PA systems."
  },
  {
    question: "Do you provide microphones?",
    answer: "Yes! We provide professional Shure microphones including wireless handheld microphones, lapel (collar) microphones, headset/ear microphones, and wired microphones depending on your event needs."
  },
  {
    question: "Can I get a custom speaker hire package?",
    answer: "Yes! We offer custom sound system hire packages across Melbourne. Tell us about your venue, audience size, and type of event and we’ll recommend the perfect setup to match your needs and budget."
  },
  {
    question: "Is there a bond or deposit required?",
    answer: "A small deposit may be required to secure your booking. Contact us for details about booking, payment options, and availability."
  }
];

// Gallery images — add real photos here as you take them at events
// Upload to S3/CloudFront, e.g. https://www.soundhiretarneit.au/gallery/my-event.jpg
export const galleryImages = [
  {
    id: 2,
    src: "/gallery/event-2.jpg",
    alt: "PA system at corporate event",
    category: "Corporate"
  },
  {
    id: 4,
    src: "/gallery/event-4.jpg",
    alt: "Sound equipment for birthday celebration",
    category: "Birthdays"
  },
  {
    id: 5,
    src: "/gallery/event-5.jpg",
    alt: "Outdoor event audio setup",
    category: "Outdoor"
  },
  {
    id: 7,
    src: "/gallery/event-7.jpg",
    alt: "Full sound system at event",
    category: "Corporate"
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1562177274-4d388b519ecf",
  speakers: "https://images.unsplash.com/photo-1595432541891-a461100d3054",
  discoLights: "https://images.unsplash.com/photo-1599739291060-4578e77dac5d",
  concert: "https://images.unsplash.com/photo-1740458983830-24bfc1118a05",
  eventSetup: "https://images.unsplash.com/photo-1675171155224-e70a5eeb27c3"
};
